import React from 'react';
import { MdCheck, MdClose } from 'react-icons/md';

import { ConfirmOptions, AlertOptions } from 'muibox';

export const defaultConfirmOptions: ConfirmOptions = {
  title: 'Es necesario confirmar',
  message: '¿Estás seguro de realizar la operación?',
  ok: {
    text: 'Aceptar',
    color: 'secondary',
    variant: 'contained',
    startIcon: <MdCheck />
  },
  cancel: {
    text: 'Cancelar',
    color: 'default',
    variant: 'contained',
    startIcon: <MdClose />
  }
};

export const defaultAlertOptions: AlertOptions = {
  title: '',
  message: '',
  ok: {
    text: 'Aceptar',
    color: 'secondary',
    variant: 'contained',
    startIcon: <MdCheck />
  },
}